import {
	getSharesPage,
    getSharesCount
} from '@/api/shares';

import Pagination from '@/components/Pagination';

export default {
	name: 'shares',
    components: {
		Pagination
	},
	data() {
		return {
			orderObj: { //订单列表
				list: [],
				total: 0,
				listLoading: false,
			},
            orderCount: { //数量
                sharerNumCount: 0,
                commissionAccountCount: 0,
                commissionCount: 0,
                orderNumCount: 0,
                userNumCount: 0,
                createTime:'',
                becomeSharerTime:''
            },
            payDate: [],
			form: {
				pageNum: 1,
				pageSize: 10,
			}
		}
	},
	beforeCreate() {

	},
	created() {
		this.getOrderPage()
	},
	methods: {
		//获取订单列表
		getOrderPage() {

            if(this.payDate){
                this.form.startTimeYMD = this.payDate[0]
                this.form.endTimeYMD = this.payDate[1]
            }else{
                this.form.startTimeYMD = ''
                this.form.endTimeYMD = ''
            }
            this.orderObj.listLoading = true;
			//获取订单列表
			getSharesPage(this.form).then(res => {
				this.orderObj.list = res.data.list;
                this.orderObj.total = res.data.total;
				this.orderObj.listLoading = false;

			})

            //获取订单统计
            getSharesCount({
                sharerTelnoLike: this.form.sharerTelnoLike,
                startTimeYMD: this.form.startTimeYMD,
                endTimeYMD: this.form.endTimeYMD
            }).then(res => {
                if(res.code == 200){
                    this.orderCount.sharerNumCount = res.data.sharerNumCount
                    this.orderCount.commissionAccountCount = res.data.commissionAccountCount
                    this.orderCount.commissionCount = res.data.commissionCount
                    this.orderCount.orderNumCount = res.data.orderNumCount
                    this.orderCount.userNumCount = res.data.userNumCount
                }
            });
		},

        gotoUsers(telno){
            this.$router.push('sharesUsers?sharerTelno='+telno)
        },
        gotoOrders(telno){
            this.$router.push('sharesOrders?sharerTelno='+telno)
        }
	}
}
